// extracted by mini-css-extract-plugin
module.exports = {"offer-price-row":"_10gg3l","price-text":"DWFdpZ","price-value":"_19_Y9G","coin-icon":"_1xbuI_","sub-text":"_3jSdaM"};